import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import { getSources, deleteSource } from "../../../store/actions";
import CategoryListing from "../categories/categoryListing";
import AddSourceForm from "./addSourceForm";

const SourceListing = ({ getSources, sourceList, deleteSource, onBack }) => {
    const [source, setCategory] = useState(null);

    useEffect(() => {
        source ? getSources(source.id) : getSources();
    }, [source, getSources]);

    const sourceOnBack = (event) => {
        setCategory(null);
        onBack && onBack(event);
    }

    const columns = [{
        Header: "Name",
        accessor: "name"
    }, {
        Header: "Notes",
        accessor: "notes"
    }];

    const deleteSourceNow = (event) => {
        const successHandler = () => {
            getSources();
        }
        deleteSource(event, successHandler);
    }

    return <CategoryListing title="Add Source" list={sourceList} item={source} onBack={sourceOnBack} deleteItem={deleteSourceNow} getList={getSources} columns={columns} addForm={AddSourceForm} initialFields={{
        name: "",
        notes: "",
        url: "",
        url_title: ""
    }} />
}

const mapStateToProps = (state) => {
    return {
        sourceList: get(state, "AddRecipe.sourceList", [])
    };
};

const mapDispatchToProps = {
    getSources,
    deleteSource
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SourceListing);